module.exports = __webpack_public_path__ + "img/FFNew.331b1fb2.png";